import React, { useEffect, useRef, useState } from "react";
import { styled } from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import Footer, { FooterMobile } from "../components/Footer";
import { Colors } from "../ColorConstants";
import LocationSection from "../components/Booking/Location";
import VisitHours from "../components/Booking/VisitHours";
import FeedbackShare from "../components/Booking/FeedbackShare";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAquaGames, getAquaProduct } from "../services/aquaServices";
import ImageSlide from "../components/Booking/ImageSlide";
import CalendarPicker from "../components/Calendar";
import UnitCounter from "../components/AquaZone/TicketCounter";
import dayjs from "dayjs";
import Button from "../components/Buttons";
import { Text } from "../TextConstants";
import AquaDropdown from "../components/AquaZone/TimeSlot";
import AquaDurationDropdown from "../components/AquaZone/Duration";
import ErrorCard from "../components/Booking/ErrorCart";
import { appendCart, clearCart, getCart } from "../services/cartServices";
import ModalContent from "../components/Booking/ModalContent";
import Modal from "react-modal";
import { EVENT } from "../analytics/constants";
import { trackFBEvent } from "../analytics";
import { getFormattedDate } from "../helper";
import CustomLoader from "../components/Loader";
import AlreadyBookedSlotModal from "../components/Booking/AlreadyBookedSlotModal";
import ModalContainer from "../components/Booking/ModalContainer";
import { WEEK_INDEX } from "../constants";
import { BackArrow, BackButton } from "../assets/icons";

const AquaZoneProduct = () => {
  const [data, setData] = useState({});
  const [date, setDate] = useState(new Date());
  const [slots, setSlots] = useState([]);
  const [durations, setDurations] = useState([]);
  const [outlet, setOutlet] = useState({});
  const [count, setCount] = useState(0);
  const [activeImgIndex, setActiveImage] = useState(0);
  const calenderRef = useRef(null);
  const imgRef = useRef(null);
  let { id } = useParams();
  const [cartData, setCartData] = useState([]);
  const [error, setError] = useState({ date: "", items: "" });
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [slotBookedModal, setSlotBookedModal] = useState(false);
  // const toggleSlotDropdown = (index) => {
  //   const updatedVisibleDropdowns = [...visible];
  //   updatedVisibleDropdowns[index] = !updatedVisibleDropdowns[index];
  //   setVisible(updatedVisibleDropdowns);
  // };
  const scrollToCard = () => {
    imgRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  useEffect(() => {
    scrollToCard();
    const apiToken = localStorage.getItem("token");
    if (apiToken) {
      fetchCart();
    } else {
      fetchAquaProduct(id, date, cartData);
      fetchAquaGames();
    }
  }, []);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "AquaZone Booking Page" });
  }, []);

  // setTimeout(() => {
  //   imgRef.current?.scrollIntoView({
  //     behavior: "smooth",
  //     block: "start",
  //   });
  // }, 0);

  const fetchCart = async () => {
    setLoading(true);
    let d = new Date();
    try {
      let res = await getCart("");
      let outletResp = await getAquaGames();
      setOutlet(outletResp?.data?.data?.outletInfo[0]);
      let date =
        res?.data?.data?.outletId === outletResp?.data?.data?.outletInfo[0]._id
          ? res?.data?.data?.bookingDate
            ? new Date(res?.data?.data?.bookingDate)
            : d
          : d;
      setDate(date);
      fetchAquaProduct(id, date, cartData);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAquaProduct = async (id, date, slotCartData) => {
    let clonedSlotCartData = JSON.parse(JSON.stringify(slotCartData))
    let filteredSlot = clonedSlotCartData?.filter(
      (data) => data.aquaDuration && data.slot
    );
    filteredSlot?.forEach((data) => delete data.price);

    setLoading(true);
    let formattedDate = dayjs(date).format("YYYY-MM-DD");
    try {
      let res = await getAquaProduct(id, formattedDate, filteredSlot);
      setSlotBookedModal(
        res?.data?.data?.blockedSlot.length > 0 ? true : false
      );
      setData(res?.data?.data);
      let slots = res?.data?.data.timeSlotDuration.map((slot) => {
        return { label: slot.value, value: slot.key, enable: slot.enable };
      });
      setSlots(slots);
      let durations = res?.data?.data.productInfo.price.map((price) => {
        return {
          label: `${price.duration} min`,
          value: price.duration,
          price: price.price,
        };
      });
      setDurations(durations);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAquaGames = async () => {
    setLoading(true);
    try {
      let res = await getAquaGames();
      setOutlet(res?.data?.data?.outletInfo[0]);
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoading(false);
    }
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path: ``,
      },
      {
        label: outlet?.name,
        path: ``,
      },
    ];
  };

  const onAddCounter = () => {
    let cart = [...cartData];
    if (data?.aquaMaxUnitPerTicket > count) {
      setCount(count + 1);
      cart.push({
        slot: "",
        aquaDuration: "",
        qty: 1,
        price: "",
      });
    }
    setCartData(cart);
  };
  const onSubtractCounter = () => {
    let cart = [...cartData];
    if (count > 0) {
      setCount(count - 1);
      cart.pop();
      setCartData(cart);
    }
  };

  const handleSelectDate = (date) => {
    setDate(date);
    fetchAquaProduct(id, date, cartData);
    setError({ ...error, date: "" });
  };

  const handleImageSelect = (index) => {
    setActiveImage(index);
  };

  const handleSlotSelection = (value, index) => {
    let cart = [...cartData];
    cart[index]["slot"] = value;
    setError({ ...error, items: "" });
    setCartData(cart);
    fetchAquaProduct(id, date, cart);
  };

  const handleDurationSelection = (value, price, index) => {
    let cart = [...cartData];
    cart[index]["aquaDuration"] = value;
    cart[index]["price"] = price;
    setCartData(cart);
    setError({ ...error, items: "" });
    fetchAquaProduct(id, date, cart);
  };

  const getTotalAmount = (cartData) => {
    let cartClone = cartData.filter((data) => data.slot && data.aquaDuration);
    const sum = cartClone.reduce((accumulator, object) => {
      return accumulator + Number(object.price);
    }, 0);
    return sum || 0;
  };

  const handleAddToCart = () => {
    let hasError = false;
    if (!date) {
      setError({ ...error, date: "Please select a date" });
      hasError = true;
    }
    let validCartLength =
      cartData.filter((data) => data.slot && data.aquaDuration).length || 0;
    let actualCartLength = cartData.length || 0;
    let cartDataClone = JSON.parse(JSON.stringify(cartData));
    if (actualCartLength === 0 || actualCartLength > validCartLength) {
      setError({ ...error, items: "Please valid slots and durations" });
      hasError = true;
    }
    if (!hasError) {
      cartDataClone.forEach((data) => delete data.price);
      let cartObj = {
        slots: cartDataClone,
        qty: cartDataClone.length,
        productId: id,
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      let postableCartObj = { items: [cartObj] };
      addToCart(postableCartObj);
    }
  };

  const addToCart = async (payload) => {
    setLoading(true);
    try {
      let res = await getCart("");
      if (res.status === 201) {
        const isEmptyObject = Object.keys(res.data.data).length === 0;
        const isSameDate =
          res?.data?.data?.bookingDate === getFormattedDate(date);
        const isSameOutlet = res?.data?.data?.outletId === outlet._id;

        if (isEmptyObject || (isSameOutlet && isSameDate)) {
          let existingCart = [];
          existingCart =
            res?.data?.data?.items?.map((item) => {
              return {
                slots: item.slots.map((slot) => {
                  return {
                    slot: slot.slot,
                    aquaDuration: slot.aquaDuration,
                    qty: slot.qty,
                  };
                }),
                qty: item?.qty,
                productId: item?.productId,
                date: item?.date,
              };
            }) || [];

          console.log(existingCart);
          let newItemProductId = payload.items[0].productId;
          console.log(newItemProductId);
          let index = -1;
          index = existingCart?.findIndex((object) => {
            return object.productId === newItemProductId;
          });
          console.log(index);
          if (index >= 0) {
            existingCart[index].slots.push(...payload.items[0].slots);
            existingCart[index].qty = existingCart[index].slots.length;
          } else {
            existingCart.push(payload.items[0]);
          }
          let postablePayload = {
            items: [...existingCart],
          };
          console.log(postablePayload);
          let appendRes = await appendCart(postablePayload);
          if (appendRes.status === 201) {
            trackFBEvent(EVENT.ADD_TO_CART, { park: outlet?.name });
            navigate(`/app/cart`);
          }
        } else {
          setIsModalOpen(true);
        }
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSlotBookedModal(false);
  };

  const handleContinue = async () => {
    let response = await clearCart();
    if (response.status === 201) {
      handleAddToCart();
    }
  };

  const filterDates = (date) => {
    if (outlet?.bookingWeekDays && outlet?.bookingWeekDays?.length > 0) {
      let d = new Date(date);
      let day = d.getDay();
      let dayString = WEEK_INDEX[day];
      return outlet.bookingWeekDays.indexOf(dayString) >= 0;
    } else {
      return true;
    }
  };

  const handleBookTickets = () => {
    calenderRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  const contactInfo = {
    email: outlet?.email,
    phone: outlet?.phone,
    actualRating: outlet?.actualRating,
    totalRating: outlet?.totalRating,
  };
  return (
    <div>
      <BackImageContainer onClick={() => navigate(`/app/aqua`)}>
        <BackImage src={BackButton} />
      </BackImageContainer>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Modal confirmation"
        style={{
          content: {
            height: "20rem",
            maxWidth: "25rem",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 999,
          },
        }}
      >
        <ModalContent closeModal={closeModal} handleContinue={handleContinue} />
      </Modal>
      <ModalContainer isOpen={slotBookedModal} closeModal={closeModal}>
        <AlreadyBookedSlotModal
          closeModal={closeModal}
          handleContinue={closeModal}
        />
      </ModalContainer>
      <BannerContainer image={outlet?.images?.[0].url} ref={imgRef} />
      <BreadCrumb
        items={getBreadCrumbData()}
        activeItem={outlet?.name}
        showCart
      />
      <AquaProductContainer>
        <AquaProductDetailsContainer>
          <AquaProductDetailsSubContainer>
            <ParkNameContainer>
              <ParkName>{outlet.name}</ParkName>
              <FeedbackWrapper>
                <FeedbackShare
                  share={false}
                  email={outlet?.email}
                  phone={outlet?.reservationNumber}
                />
              </FeedbackWrapper>
            </ParkNameContainer>
            <ImageSlide
              imageArray={outlet?.images}
              activeImgIndex={activeImgIndex}
              onImageSelect={handleImageSelect}
            />
            <ParksDetail>
              <ParkDescription>{outlet?.description}</ParkDescription>
              <VisitHours visitHours={outlet?.visitingHoursOrderBy || []} />
              <LocationSection location={outlet?.address} />
            </ParksDetail>
          </AquaProductDetailsSubContainer>
          <ProductDetailsContainer>
            <ProductDetailMobile>
              <ParksInfoContainer>
                <ParkName>{outlet?.name}</ParkName>
                <ParkInfoSubContainer>
                  <Button
                    variant="filled"
                    label="Book Tickets"
                    padding="0.35rem 1rem"
                    width="100%"
                    onClick={handleBookTickets}
                  />
                  <FeedbackSpace>
                    <FeedbackShare
                      share={false}
                      email={outlet?.email}
                      phone={outlet?.reservationNumber}
                    />
                  </FeedbackSpace>
                </ParkInfoSubContainer>
              </ParksInfoContainer>
              <ParkDescription>{outlet?.description}</ParkDescription>
              <VisitHours
                visitHours={outlet?.visitingHoursOrderBy || []}
                contactInfo={contactInfo || []}
              />
              <LocationSection location={outlet?.address} />
            </ProductDetailMobile>
            <ProductDetailsSubContainer>
              <ProductNameContainer>
                <ProductNameText>{Text.productName}</ProductNameText>
                <ProductNameDetail>{data?.productInfo?.name}</ProductNameDetail>
              </ProductNameContainer>
              <div ref={calenderRef}>
                <CalendarPicker
                  showHelper={false}
                  onSetDate={handleSelectDate}
                  date={date}
                  filterDate={filterDates}
                  // error={error.date}
                  // minDate={data?.startDate}
                />
              </div>
              <UnitContainer>
                <UnitTitle>{Text.numberUnits}</UnitTitle>
                <UnitCounter
                  onAdd={onAddCounter}
                  onSubtract={onSubtractCounter}
                  count={count}
                />
              </UnitContainer>
              <TimeslotContainer>
                <TimeslotTitle>{Text.timeSlot}</TimeslotTitle>
                {cartData.map((slot, index) => (
                  <DropdownView>
                    <AquaDropdown
                      width="55%"
                      data={slots}
                      placeholder="Select a slot"
                      cartindex={index}
                      selected={cartData[index].slot}
                      onSelect={handleSlotSelection}
                    />
                    <AquaDurationDropdown
                      width="40%"
                      data={durations}
                      placeholder="Select duration"
                      cartindex={index}
                      selected={cartData[index].aquaDuration}
                      onSelect={handleDurationSelection}
                    />
                  </DropdownView>
                ))}
              </TimeslotContainer>
              <RequestContainer>
                <RequestText>{Text.requestText}</RequestText>
              </RequestContainer>
              <RideDetailContainer>
                <RideContainer>
                  <TitleText>{Text.ride}</TitleText>
                  <DetailText>
                    {cartData.filter((data) => data.slot && data.aquaDuration)
                      ?.length || 0}
                    <span>{data?.productInfo?.name}</span>
                  </DetailText>
                </RideContainer>
                <RideContainer>
                  <TitleText>{Text.total}</TitleText>
                  <DetailText>
                    {cartData.length > 0 && getTotalAmount(cartData)} QAR
                  </DetailText>
                </RideContainer>
              </RideDetailContainer>
              <ErrorCard errorObj={error} />
              <Button
                variant="filled"
                label="Rent Now"
                onClick={handleAddToCart}
              />
              <CompleteText>
                Complete your booking within <span>15</span> minutes
              </CompleteText>
            </ProductDetailsSubContainer>
          </ProductDetailsContainer>
        </AquaProductDetailsContainer>
      </AquaProductContainer>
      {loading ? <CustomLoader /> : <></>}
      <FooterContainer>
        <Footer />
      </FooterContainer>
      <FooterMobile />
    </div>
  );
};
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;
const BannerContainer = styled.div`
  background-image: url(${(props) => props.image});
  height: 20rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  padding: 4.5rem 0;
  box-sizing: border-box;

  @media (max-width: 43.75rem) {
    height: 15rem;
  }
`;
const AquaProductContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 4rem;
  @media only screen and (max-width: 1024px) {
    padding-top: 1.5rem;
  }
`;
const AquaProductDetailsContainer = styled.div`
  width: 1024px;
  gap: 4rem;
  display: flex;
`;

const AquaProductDetailsSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 1.5rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const ParkNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // margin-top: -0.8rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const ParkName = styled.div`
  font-size: 2rem;
  font-weight: 700;
  width: 65%;
  @media only screen and (max-width: 1024px) {
    font-size: 2rem;
    font-weight: 700;
  }
  @media only screen and (max-width: 414px) {
    width: 60%;
  }
`;
const FeedbackWrapper = styled.div`
  padding: 0.2rem 0rem;
  @media only screen and (max-width: 1024px) {
    padding: 0rem;
  }
`;
const ParksDetail = styled.div`
  display: flex;
  flex-direction: column;
  overflow: overflow;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const ParkDescription = styled.div`
  font-size: 1rem;
  font-weight: 400;
  text-align: justify;
`;
const ProductDetailsContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 1rem;
  }
`;
const ProductDetailMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0rem;
  @media only screen and (min-width: 1024px) {
    display: none;
  }
`;

const ParksInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  // border: 1px solid red;
  align-items: flex-start;
`;
const ParkInfoSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  // border: 1px solid red;
  // width: 50%;
  height: 100%;
  align-items: flex-end;
  // gap: 1rem;
  margin-top: 0.6rem;
  // @media only screen and (max-width: 414px) {
  //   width: 40%;
  // }
`;
const FeedbackSpace = styled.div`
  display: none;
  // width: 100%;
  // height: 40%;
  // align-items: center;
  // justify-content: flex-end;
  // margin-top: 0.6rem;
`;
const ProductDetailsSubContainer = styled.div`
  //   width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 1024px) {
    // width: 100%;
    // padding: 0 1rem;
  }
`;
const ProductNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ProductNameText = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
`;
const ProductNameDetail = styled.span`
  color: ${Colors.darkBlue};
  text-align: right;
  font-size: 2rem;
  font-weight: 300;
  @media only screen and (max-width: 1024px) {
    font-size: 1.5rem;
  }
`;
const UnitContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
`;
const TimeslotContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;
const TimeslotTitle = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
`;
const DropdownView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // align-items: center;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    margin-bottom: 1.5rem;
  }
`;
const UnitTitle = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
`;
const RequestContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${Colors.lightBlack2};
  padding: 0.1rem 0 0.3rem 0;
  margin-top: 2rem;
`;
const RequestText = styled.span`
  color: ${Colors.dustyGray};
  font-size: 0.8rem;
  font-weight: 300;
`;
const RideDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  padding-bottom: 1rem;
`;
const RideContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem 0rem;
`;
const TitleText = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
`;
const DetailText = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
  > span {
    font-size: 1.25rem;
    font-weight: 400;
    margin-left: 0.3rem;
  }
`;
const CompleteText = styled.span`
  color: ${Colors.black};
  text-align: center;
  font-size: 0.8rem;
  font-weight: 400;
  opacity: 0.9;
  > span {
    color: ${Colors.aqua};
  }
`;
const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

export default AquaZoneProduct;
